import { render, staticRenderFns } from "./wb-widget-workbench.vue?vue&type=template&id=21681528&scoped=true"
import script from "./wb-widget-workbench.vue?vue&type=script&lang=js"
export * from "./wb-widget-workbench.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21681528",
  null
  
)

export default component.exports